function initConsentMap() {
  const container = document.querySelector('.map-container');

  if (!container) return;

  const loadMap = () => {
    const src = container.getAttribute('data-map-src');
    const iframe = document.createElement('iframe');

    iframe.className = 'map';
    iframe.src = src;
    container.innerHTML = '';
    container.appendChild(iframe);
  }

  if (!window.TreatwellCookieConsent) {
    loadMap();

    return;
  }

  window.TreatwellCookieConsent().then((api) => {
    if (api.getActiveGroups().includes('targeting')) {
      loadMap();
    }
  });
}
